export default __webpack_public_path__ + "static/ak-cached/24h/media/mgm+.e46b2ffd.png";